module.exports = __webpack_public_path__ + "img/LOGO.3b848114.svg";